import {isNil} from 'ramda';
import {isNotNilOrEmpty} from 'ramda-adjunct';

import {useGetVehiclePhotosQuery} from '@dms/api/sales';
import {useListSaleVehiclePhotosByVehicleQuery} from '@dms/api/vehicle';

import {Nullish} from 'shared/web';

import {useVehiclePhotosPermissions} from './useVehiclePhotosPermissions';

export function useVehicleCoverPhoto(vehicleId: string | Nullish) {
  const {canReadVehicleAlbumPhotos} = useVehiclePhotosPermissions({
    vehicleId: vehicleId ?? '',
  });

  const {data: saleVehiclePhotos} = useListSaleVehiclePhotosByVehicleQuery(
    {
      vehicleId: vehicleId ?? '',
    },
    {
      skip: !canReadVehicleAlbumPhotos || isNil(vehicleId),
    }
  );

  const hasSalePhotos = isNotNilOrEmpty(saleVehiclePhotos?.photos);

  // Fall back to the vehicle-centric endpoint for vehicles that don't participate
  // in the sale flow (service / rental). Sale vehicles keep using the legacy
  // sale-vehicle photo-by-vehicle endpoint.
  const {data: vehiclePhotos} = useGetVehiclePhotosQuery(
    {vehicleId: vehicleId ?? ''},
    {skip: !canReadVehicleAlbumPhotos || isNil(vehicleId) || hasSalePhotos}
  );

  const photos = hasSalePhotos ? (saleVehiclePhotos?.photos ?? []) : (vehiclePhotos ?? []);

  const coverPhoto = photos.find((photo) => photo.isCoverPhoto);

  return {
    photos,
    coverPhoto,
  };
}
